const RETRY_INTERVAL_MS = 500;
const MAX_RETRIES = 60;

// Multiple sources (routes, viewport-fixed action bars) can ask for the launcher
// to be hidden at the same time, so track them by reason instead of a boolean.
const hideReasons = new Set<string>();

let retryId: number | undefined;
let retryCount = 0;
let closeListenerBound = false;

const stopRetrying = () => {
  if (retryId) {
    window.clearInterval(retryId);
    retryId = undefined;
  }
  retryCount = 0;
};

const applyNow = () => {
  if (typeof window.zE !== 'function') return false;
  window.zE('messenger', hideReasons.size > 0 ? 'hide' : 'show');
  return true;
};

// The snippet injects `zE` asynchronously, and it is never injected at all when
// the app runs inside an iframe, hence the bounded retry.
const applyZendeskVisibility = () => {
  if (applyNow()) {
    stopRetrying();
    return;
  }
  if (retryId) return;
  retryCount = 0;
  retryId = window.setInterval(() => {
    retryCount += 1;
    if (applyNow() || retryCount >= MAX_RETRIES) {
      stopRetrying();
    }
  }, RETRY_INTERVAL_MS);
};

export const addZendeskHideReason = (reason: string) => {
  hideReasons.add(reason);
  applyZendeskVisibility();
};

export const removeZendeskHideReason = (reason: string) => {
  hideReasons.delete(reason);
  applyZendeskVisibility();
};

export const isZendeskAvailable = () => typeof window.zE === 'function';

// Opening from a menu has to override any active hide reason, otherwise the
// messenger window stays invisible. Visibility is restored once it is closed.
export const openZendesk = () => {
  if (typeof window.zE !== 'function') return;

  if (!closeListenerBound) {
    closeListenerBound = true;
    window.zE('messenger:on', 'close', () => applyZendeskVisibility());
  }

  window.zE('messenger', 'show');
  window.zE('messenger', 'open');
};
